import { Component, OnInit } from '@angular/core';
import { VerifyOtpRequest } from './verify-otp-request';
import { NGXLogger } from 'ngx-logger';
import { SharedService } from '../shared.service';
import { OTPResponse } from '../registeration/gen-otp-response';
import { UserRegiester } from '../registeration/user-registeration';
import { PopUpService } from '../PopUpService';
import { GenOTPRequest } from '../registeration/gen-otp-request';
import { Router } from '@angular/router';
import { EkpayUser } from '../../user/ekpay_user';
import { Subscription } from 'rxjs';
import { DataStorageService } from '../data-storage.service';
import { ChangeMobileRequest } from '../../user/change-mobile/change-mobile';
import { UserService } from '../../user/user.service';
import { AccountService } from '../auth/account.service';
import { AuthServerProvider } from '../auth/auth-jwt.service';
import { Principal } from '../auth/principal.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
declare var AesUtil: any;
@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {

  constructor(private userService: UserService, 
    private accountService: AccountService, 
    private sharedService: SharedService, 
    private logger: NGXLogger, private popupservice: PopUpService, private router: Router,
    private dataStorageService: DataStorageService,
    private authService: AuthServerProvider,
    private principal: Principal,
    private translate: TranslateService,
    private $localStorage:LocalStorageService) {
  }

  verifyOtp: VerifyOtpRequest;
  otpResponse: OTPResponse;
  userRegiester: UserRegiester;
  ekpayUser: EkpayUser;
  getotpReq: GenOTPRequest;
  userNo: string;
  isReady: boolean = false;
  isOtpValid: boolean = false;
  isSucc: boolean = false;
  subscription: Subscription;
  user: EkpayUser;
  changeMobReq: ChangeMobileRequest;
  lang: string;

  ngOnInit() {
    this.logger.debug("calling otp component..");
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.logger.debug('data lang is ' + this.lang);
      this.translate.use(this.lang);
    })
    this.verifyOtp = new VerifyOtpRequest();
    this.getotpReq = new GenOTPRequest();
    if (sessionStorage.getItem("otpType") == 'forgotpassword' || sessionStorage.getItem("otpType") == 'loginwithotp') {
      // this.ekpayUser = JSON.parse(sessionStorage.getItem("otp_response")) as EkpayUser;
      this.userNo = "XXXXXXX" + JSON.parse(sessionStorage.getItem("otp_response")).mobile.substr(7, 10)
    } else if (sessionStorage.getItem("otpType") == 'changemobilewithotp') {
      this.getotpReq = JSON.parse(sessionStorage.getItem("getotpReq")) as GenOTPRequest;
      this.userNo = "XXXXXXX" + this.getotpReq.mobile.substr(7, 10)
    } else {
      this.userRegiester = JSON.parse(sessionStorage.getItem("otp_response")) as UserRegiester;
      this.userNo = "XXXXXXX" + this.userRegiester.mobile.substr(7, 10)
    }
    this.isReady = true;
  }

  verifyOTP() {
    this.verifyOtp.otpId = sessionStorage.getItem("otp_id");

    if (sessionStorage.getItem("otpType") == 'loginwithotp') {
      this.logger.debug("request...." + JSON.stringify(this.verifyOtp));
      this.sharedService.getOtpAuthentication(this.verifyOtp).subscribe(data => {
        this.logger.debug("response...." + JSON.stringify(data.body));
        if (data.body.status == "success") {
          this.authService.storeAuthenticationToken(data.body.id_token, true);
          // this.$localStorage.store('authenticationToken', data.body.id_token);
          this.principal.identity(true).then((account) => {
            if (account !== null) {
              this.logger.debug('account is not null' + JSON.stringify(account));
              this.ekpayUser = account;
              this.dataStorageService.setUserData(this.ekpayUser);
              localStorage.setItem("sessuser", JSON.stringify(this.ekpayUser));
              this.popupservice.isOtp = false;
              this.router.navigate(['']);
            }
          });
        } else {
          this.otpResponse = new OTPResponse();
          this.otpResponse.reason = data.body.reason;
          this.isOtpValid = true;
        }
      });
    } else {
      this.sharedService.verifyOTP(this.verifyOtp).subscribe((data) => {
        this.isReady = false;
        this.logger.debug("calling get otp method...." + JSON.stringify(data));
        this.otpResponse = data.body as OTPResponse;
        if (this.otpResponse.status == "success") {
          if (sessionStorage.getItem("otpType") == 'forgotpassword') {
            this.logger.debug("forget otp Verified....");
            this.popupservice.isChangePassword = true;
            this.popupservice.isOtp = false;
          } else if (sessionStorage.getItem("otpType") == 'changemobilewithotp') {
            this.logger.debug("change mobile with otp calling...");
            this.changeMobReq = new ChangeMobileRequest();
            this.changeMobReq.ekpay_id = this.getotpReq.ekpayId;
            this.changeMobReq.mobile = this.getotpReq.mobile;
            this.userService.changeMobile(this.changeMobReq).subscribe((data) => {
              this.logger.debug("response...." + JSON.stringify(data));
              this.accountService.get().toPromise().then((account) => {
                // var iterationCount = 1000;
                // var keySize = 128;
                // var aesUtil = new AesUtil(keySize, iterationCount);
                // var ciphertext2 = aesUtil.decrypt("8bc82ffe516ea1f1b89dcb529a201d56", "ebb7947b5feabdc0b60f2a694fa259c4", "aks@Samuel#Rishi", account.name);
                // console.log('ciphertext2 is >>>>' + JSON.stringify(ciphertext2));
                this.user=account as EkpayUser;
                this.dataStorageService.setUserData(this.user);
                this.logger.debug('account in identity...' + JSON.stringify(this.user));
                //this.user = account as EkpayUser;
                this.dataStorageService.setUserData(this.user);
                localStorage.setItem("sessuser", JSON.stringify(this.user));
                this.popupservice.isOtp = false;
                this.popupservice.isSuccessInfo = true;
                this.router.navigate(['success-info']);
              });
            });
          } else {
            this.isSucc = true;
            this.logger.debug("going to save user...." + JSON.stringify(this.userRegiester));
            this.sharedService.registerUser(this.userRegiester).subscribe((data) => {
              this.logger.debug("calling to save user...." + JSON.stringify(data));
              this.otpResponse = data.body as OTPResponse;
              this.popupservice.title = this.otpResponse.status;
            });
          }
        } else {
          this.isReady = true;
          this.isOtpValid = true;
        }
      });
    }


  }

  closeOTPUp() {
    this.popupservice.isOtp = false;
  }
  getFalse(){
    this.isOtpValid=false;
  }

  resendOtp() {
    this.isReady = false;
    this.verifyOtp.otp = "";
    this.getotpReq = JSON.parse(sessionStorage.getItem("getotpReq"));
    this.sharedService.getOTP(this.getotpReq).subscribe((data) => {
      this.logger.debug("calling get otp method...." + JSON.stringify(data));
      this.otpResponse = data.body as OTPResponse;
      if ("success" == this.otpResponse.status) {
        this.isReady = true;
        this.popupservice.isEnable = true;
        this.popupservice.isOtp = true;
        this.popupservice.isLogin = false;
        this.popupservice.isRegister = false;
        this.popupservice.title = "Enter OTP";
        sessionStorage.setItem("otp_id", this.otpResponse.otp.otp_id);
        sessionStorage.setItem("otp_response", JSON.stringify(this.userRegiester));
      }
    });
  }

  login() {
    this.popupservice.title = "login"
    this.popupservice.isEnable = true;
    this.popupservice.isRegister = false;
    this.popupservice.isLogin = true;
    this.popupservice.isOtp = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/otp/otp.component.ts